module.exports = __webpack_public_path__ + "static/media/Barrister.4785fbbe.jpeg";